import { GetCompanyQuery, GitHubInstallationStatus, TicketingAcquisitionMethod } from '../graphql';

type CompanyTicketingToken = GetCompanyQuery['getCompany']['ticketingTokens'][number];

/**
 * Whether a ticketing token represents a connection that can actually sync.
 *
 * For the Merge-acquired providers the row only exists after a successful connect, so its existence
 * is the answer. A GITHUB_APP row is different: `createGitHubAppInstallUrl` arms it as PENDING at
 * mint time, before the browser even leaves for GitHub, and it only goes ACTIVE once the signed
 * `installation.created` webhook lands (ADR 0003). Treating that armed row as connected marks the
 * get-started step complete, disables the provider tile the retry path needs, and offers a
 * connection that can sync nothing as an analysis source — all for an install that may never have
 * completed. SUSPENDED and DELETED are likewise not connections that can sync.
 */
export const isTicketingTokenConnected = (token: CompanyTicketingToken): boolean =>
  token.acquisitionMethod === TicketingAcquisitionMethod.GithubApp
    ? token.installationStatus === GitHubInstallationStatus.Active
    : true;
